export const APP_VERSION = '1.0.0';
export const VERSION_INFO = `v${APP_VERSION} - Powered by CV Printing S.A.S`; 